module.exports = "<div *ngIf=\"result\">\n  <h3>{{ result }}</h3>\n</div>"